export default "__VITE_ASSET__idOCXPBW__"